import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCards = ({ metrics }) => {
  const metricItems = [
    {
      key: 'processed',
      label: 'Tracks Processed',
      value: metrics.processed,
      total: metrics.total,
      icon: 'Music',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      key: 'successful',
      label: 'Successful Matches',
      value: metrics.successful,
      total: metrics.processed,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      key: 'failed',
      label: 'Failed Matches',
      value: metrics.failed,
      total: metrics.processed,
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      key: 'duplicates',
      label: 'Duplicates Handled',
      value: metrics.duplicates,
      total: metrics.processed,
      icon: 'Copy',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    }
  ];

  const getPercentage = (value, total) => {
    if (total === 0) return 0;
    return Math.round((value / total) * 100);
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {metricItems.map((item) => (
        <div key={item.key} className="bg-surface border border-border rounded-lg p-4">
          <div className="flex items-center space-x-3 mb-3">
            <div className={`p-2 rounded-lg ${item.bgColor}`}>
              <Icon name={item.icon} size={20} className={item.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-text-muted uppercase tracking-wide">
                {item.label}
              </p>
            </div>
          </div>
          
          <div className="space-y-2">
            <div className="flex items-baseline space-x-2">
              <span className="text-2xl font-bold text-text-primary">
                {item.value.toLocaleString()}
              </span>
              {item.total > 0 && (
                <span className="text-sm text-text-secondary">
                  / {item.total.toLocaleString()}
                </span>
              )}
            </div>
            
            {item.total > 0 && (
              <div className="space-y-1">
                <div className="flex justify-between text-xs">
                  <span className="text-text-muted">Progress</span>
                  <span className={item.color}>
                    {getPercentage(item.value, item.total)}%
                  </span>
                </div>
                <div className="w-full bg-surface-secondary rounded-full h-1.5">
                  <div 
                    className={`h-1.5 rounded-full transition-all duration-300 ${
                      item.key === 'processed' ? 'bg-primary' :
                      item.key === 'successful' ? 'bg-success' :
                      item.key === 'failed'? 'bg-error' : 'bg-accent'
                    }`}
                    style={{ width: `${getPercentage(item.value, item.total)}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsCards;